<template>
    <ToggleListInput
        v-model="model"
        :class="{'has-error': showValidation}"
        :label="label"
        :options="options"
        :can-toggle-all="options.length > 1"
        :empty-label="emptyLabel"
        :disabled="disabled">
        <div v-if="showValidation" class="card-body">
            <div class="alert alert-danger">
                <ul class="my-0">
                    <li v-for="(error, index) in errors" :key="index" class="text-danger">
                        {{ $t(error) }}
                    </li>
                </ul>
            </div>
        </div>

        <slot />
    </ToggleListInput>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import ToggleListInput from '@/js/components/common/inputs/ToggleListInput';

export default {
    name: 'ToggleListField',

    components: {ToggleListInput},

    mixins: [FieldMixin],

    props: {
        value: {type: Array, default: () => []},
        options: {type: Array, required: true},
        emptyLabel: {type: String, default: null},
        disabled: {type: Boolean},
    },

    methods: {
        format(values) {
            if (!Array.isArray(values)) {
                return [];
            }

            return values.map((value) => Number(value));
        },

        validate(values) {
            const errors = [];

            if (this.required && (!values || values.length === 0)) {
                errors.push(this.$t('validation.custom.required'));
            }

            this.modelErrors = errors;
        },
    },
};
</script>
